export default "__VITE_ASSET__Ci23N1bo__"